import { getSubscriptionState, getUserRole } from '../user';
import { getUserSession } from './getUserSession';

const collectGenericInfoProperties = (user) => {
  const { sessionId, sessionCreationDate } = getUserSession();
  return {
    user_id: user.userId,
    role: getUserRole(user),
    subscription_state: getSubscriptionState(user),
    shipping_country: user.shippingCountry ?? '',
    sessionId,
    sessionCreationDate,
  };
};

export default collectGenericInfoProperties;
